import React, { useState } from 'react';
import { Layout } from './components/layout/Layout';
import { Dashboard } from './components/dashboard/Dashboard';
import { BioAgeAnalyzer } from './components/features/BioAgeAnalyzer';
import { DailyProtocols } from './components/features/DailyProtocols';
import { SupplementPlanner } from './components/features/SupplementPlanner';
import { AgelessWissen } from './components/features/AgelessWissen';
import { Challenges } from './components/features/Challenges';
import { FastingTool } from './components/features/FastingTool';
import { MoodTracker } from './components/features/MoodTracker';
import { SmartLabs } from './components/features/SmartLabs';
import { Community } from './components/features/Community';
export function App() {
  const [activeScreen, setActiveScreen] = useState('dashboard');
  const renderScreen = () => {
    switch (activeScreen) {
      case 'dashboard':
        return <Dashboard onNavigate={setActiveScreen} data-id="element-0" />;
      case 'bioage':
        return <BioAgeAnalyzer data-id="element-1" />;
      case 'protocols':
        return <DailyProtocols data-id="element-2" />;
      case 'supplements':
        return <SupplementPlanner data-id="element-3" />;
      case 'wissen':
        return <AgelessWissen data-id="element-4" />;
      case 'challenges':
        return <Challenges data-id="element-5" />;
      case 'fasting':
        return <FastingTool data-id="element-6" />;
      case 'mood':
        return <MoodTracker data-id="element-7" />;
      case 'labs':
        return <SmartLabs data-id="element-8" />;
      case 'community':
        return <Community data-id="element-9" />;
      default:
        return <Dashboard onNavigate={setActiveScreen} data-id="element-10" />;
    }
  };
  return <Layout activeScreen={activeScreen} onNavigate={setActiveScreen} data-id="element-11">
      {renderScreen()}
    </Layout>;
}